import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo } from 'use-memo-one'

import { useAppRoutes } from '@root/features/routing'

import {
  exploreCookingModel,
  exploreTopGainersModel,
} from '../../atoms/reatom-explore-top-gainers'
import { ExploreFeedType } from '../../model/explore-feed-type'

import { ExploreList } from './explore-list'

import type {
  ExploreTopGainersModel,
  ExploreTopGainersTab,
} from '../../atoms/reatom-explore-top-gainers'
import type { Pair } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

export type ExploreTopGainersListProps = {
  onItemClick?: (options: { pair: Pair.PairMinimal }) => void
  offsetBottom?: number | string | undefined
} & ClassNameProps

export const ExploreTopGainersList: React.FC<
  ExploreTopGainersListProps &
    (
      | { model: ExploreTopGainersModel; tab?: never }
      | { model?: never; tab: ExploreTopGainersTab }
    )
> = ({ tab, onItemClick, offsetBottom, model: initialModel }) => {
  const model = useMemo(() => {
    if (initialModel) {
      return initialModel
    } else {
      if (tab === ExploreFeedType.Cooking) {
        return exploreCookingModel
      }
      return exploreTopGainersModel
    }
  }, [initialModel, tab])
  const [pairsState] = useAtom(model.resolvedPairsStateAtom)
  const load = useAction(model.load)
  const { navigateToTrading } = useAppRoutes()
  return (
    <ExploreList
      onItemClick={
        onItemClick
          ? onItemClick
          : ({ pair }) => navigateToTrading(pair.address, pair.network)
      }
      statsPeriod={model.period}
      priceChartInterval="minutes"
      onRetry={load}
      offsetBottom={offsetBottom}
      pairsState={pairsState}
    />
  )
}
